import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { spacing } from '@retailer-platform/shared-components'

const Wrapper = styled.div({
  display: 'flex',
  marginBottom: spacing.X32,
})

export const CollectionsViewRow: FunctionComponent = ({ children }) => <Wrapper>{children}</Wrapper>
